<template>
  <el-empty v-if="!typeId" description="请先选择分类" />
  <el-table v-else :data="datalist" row-key="Id" height="100%" default-expand-all>
    <el-table-column prop="Name" label="名称" min-width="180" show-overflow-tooltip />
    <el-table-column prop="Code" label="编码" min-width="150" />
    <el-table-column prop="Sort" label="#" min-width="60" align="center" />
    <el-table-column width="150">
      <el-link slot="header" type="primary" icon="el-icon-plus" @click="openForm()">新增</el-link>
      <template slot-scope="{ row }">
        <el-link type="primary" icon="el-icon-edit" @click="openForm(row)">修改</el-link>
        <el-link v-if="!row.children" type="danger" icon="el-icon-delete" @click="onDelete(row.Id)">删除</el-link>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import form from './form.vue'
export default {
  data () {
    return {
      typeId: null,
      datalist: []
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    loadData () {
      this.$apis.system.meta.itemList({
        typeId: this.typeId,
        pid: null
      }).then(res => {
        this.datalist = res
      })
    },
    //编辑
    openForm (row) {
      this.$layer.iframe({
        title: "分项编辑",
        content: {
          content: form,
          parent: this,
          data: {
            _detail: row || { TypeId: this.typeId }
          }
        }
      })
    },
    onDelete (id) {
      this.$apis.system.meta.itemDelete({ id: id }).then(res => {
        this.$message({ message: res || "数据删除成功！", type: "success" })
        this.loadData()
      }).catch(e => {
        this.$message.error(e || "执行错误")
      })
    }
  }
}
</script>